// extracted by css-extract-rspack-plugin
export default {"faqs":"Faqs-module__faqs--wCahp","accordion-head":"Faqs-module__accordion-head--NMPZE"};